<template>
    <div class="g cart-info-aside">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .g.cart-info-aside {
        width: 25%;
        padding-left: $interval-xl;

        @include media('center') {
            width: auto;
            padding-left: 0;
        }

        &::v-deep {

            .md {

                + .md {
                    margin-top: $interval-l;
                }
            }
        }
    }
</style>
